module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("“This comprehensive resource describes every aspect of celiac disease, including diagnosis and daily survival skills. There is an entire chapter which contains invaluable advice from those with the most experience—people with celiac disease!”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthangingn"
  }, [_vm._v("—Trisha B. Lyons, RD, LD, MetroHealth Medical Center, Cleveland, OH")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("“A clear and comprehensive guide for anyone newly diagnosed with celiac disease, complete with valuable resources.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthangingn"
  }, [_vm._v("—Jessica Hale and Yvonne Gifford "), _c('em', [_vm._v("("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.glutenfreeda.com",
      "target": "_blank"
    }
  }, [_vm._v("www.glutenfreeda.com")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("“An excellent resource for those dealing with celiac disease and also for those who care for people with the disease. An invaluable tool with loads of resources and useful information presented in a concise, easy-to-understand manner!”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthangingn"
  }, [_vm._v("—Marla Doersch, RD")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("“A wonderfully comprehensive and invaluable guide to celiac disease, complete with the collective wisdom of the celiac community.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthangingn"
  }, [_vm._v("—Bonnie J. Kruszka, author of "), _c('em', [_vm._v("Eating Gluten-Free with Emily")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("“This book is full of practical and helpful information on gluten-free living along with valuable tips and recipes from the experts themselves—those with celiac disease. This book would be a welcome addition to the celiac bookshelf!”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthangingn"
  }, [_vm._v("—Shelley Case, BSc, RD, author of "), _c('em', [_vm._v("Gluten-Free Diet: A Comprehensive Resource Guide")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565e60e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01.vue
// module id = 60
// module chunks = 0